import React, { PureComponent } from 'react';
import Wizard, { WizardStep } from '@cimpress-technology/ff-react-components/lib/Wizard';
import { connect } from 'react-redux';
import { css } from 'emotion';
import SkuSelectStep from './SkuSelectStep';
import UpdateStep from './UpdateStep';
import { updateTerms, PENDING } from '../../reducers/termselect/actions';
import BasicLayout from '../layouts/BasicLayout';
import BreadcrumbsEntry from '../common/breadcrumbs/BreadcrumbsEntry';

const wizardBodyStyle = css({
  backgroundColor: '#FFF',
  borderRadius: '2px',
  padding: '30px 30px 30px'
});

const wizardStepperStyle = css({
  padding: '0 70px'
});

const wizardStyle = css({
  '& > .wizard > .wizard__body': wizardBodyStyle,
  '& > .wizard > .wizard__stepper': wizardStepperStyle
});

const SKU_SELECT = 'SKU_SELECT';

const UPDATE = 'UPDATE';

class BulkUpdateWizard extends PureComponent {
  state = {
    active: SKU_SELECT
  };

  onChangeStep = active => this.setState({ active });

  onUpdate = () => {
    const { selectedTerms, selectedSkus, termType, updateTerms } = this.props;
    updateTerms(selectedTerms, selectedSkus, termType);
  };

  render() {
    const { active } = this.state;
    const { updateRequestStatus } = this.props;
    const loading = updateRequestStatus === PENDING;
    const skuStep = (
      <WizardStep key={SKU_SELECT} name={SKU_SELECT} title="Select Products">
        <SkuSelectStep onUpdate={this.onUpdate} />
      </WizardStep>
    );

    const updateStep = (
      <WizardStep key={UPDATE} name={UPDATE} title="Update Contracts">
        <UpdateStep loading={loading} />
      </WizardStep>
    );

    return (
      <BreadcrumbsEntry title={{ translationKey: 'breadcrumbs:bulkUpdate' }}>
        <BasicLayout>
          <div className={wizardStyle}>
            <Wizard active={active} hideStepper onChangeStep={this.onChangeStep}>
              {skuStep}
              {updateStep}
            </Wizard>
          </div>
        </BasicLayout>
      </BreadcrumbsEntry>
    );
  }
}

const mapStateToProps = state => ({
  termType: state.termSelectReducer.termType,
  selectedTerms: state.termSelectReducer.selectedTerms,
  selectedSkus: state.termSelectReducer.selectedSkus,
  updateRequestStatus: state.termSelectReducer.updateRequestStatus
});

const mapDispatchToProps = dispatch => ({
  updateTerms: (selectedTerms, selectedSkus, termType) => dispatch(updateTerms(selectedTerms, selectedSkus, termType))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BulkUpdateWizard);
